import { includeSpecialCharacters, invalidPhoneNumber } from "./functions";

const validationFunctions = {
  required: ({ value }) => !value.trim(),
  isLargerNumber: ({ value, maxNumberAllow }) => Number(value) > maxNumberAllow,
  isBetween: ({ value, max, min }) => {
    return !(Number(value) >= min && Number(value) <= max);
  },
  maxLength: ({ value, len }) => value.length > len,
  includeSpecialCharacters: ({ value }) => includeSpecialCharacters(value),
  isPhoneNumber: ({ value }) => invalidPhoneNumber(value),
};

export default validationFunctions;
